import { useEffect, useState } from 'react';
import { getProgramAvailability } from '@/shared/services/programService';

/**
 * Which programs are switched on this term, for pages that are read signed
 * out and so have no term verdicts: `{ la, si, ta }`, each a boolean.
 *
 * Null until the server answers, and null if it never does. A page then shows
 * no "Coming soon" state rather than guessing one; the server still refuses a
 * switched-off program on every write.
 *
 * @returns {{ la: boolean, si: boolean, ta: boolean } | null}
 */
export default function useProgramAvailability() {
    const [active, setActive] = useState(null);

    useEffect(() => {
        let cancelled = false;
        getProgramAvailability()
            .then((data) => {
                if (!cancelled) setActive(data?.active ?? null);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    return active;
}
